const DEFAULT_UTM_PARAMS = {
  utm_campaign: 'international_travel',
  utm_source: 'acko_web',
};

const getUTMParams = () => {
  if (typeof window === 'undefined') return DEFAULT_UTM_PARAMS;

  const urlParams = new URLSearchParams(window.location.search);
  return {
    utm_campaign:
      urlParams.get('utm_campaign') || DEFAULT_UTM_PARAMS.utm_campaign,
    utm_source: urlParams.get('utm_source') || DEFAULT_UTM_PARAMS.utm_source,
  };
};

export const appendUTMParams = (url: string): string => {
  const params = getUTMParams();
  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryString}`;
};
